// extracted by mini-css-extract-plugin
export default {"transcriptProcessing":"zr16y9xx5tBaEhxI"};